<div class="intercation-container">
    <div class="title">{{ 'mimic.settings.bar.title' | translate }}</div>
    <fieldset class="fieldset" [class.selected]="showingScaleType">
        <legend class="legend" [class.selected]="showingScaleType">
            {{ 'mimic.settings.bar.scale.legend' | translate }}
        </legend>
        <mat-select
            class="input"
            panelClass="bar-element-panel"
            [(ngModel)]="scaleType"
            [hideSingleSelectionIndicator]="true"
            (selectionChange)="handleScaleChange()"
            (openedChange)="showingScaleType = !showingScaleType">
            <mat-option
                *ngFor="let scaleOption of ScaleTypeOptions"
                [value]="scaleOption.value"
                class="bar-element-option">
                {{ scaleOption.text | translate }}
            </mat-option>
        </mat-select>
    </fieldset>

    <fieldset class="fieldset" [class.selected]="showingIntervals">
        <legend class="legend" [class.selected]="showingIntervals">
            {{ 'mimic.settings.bar.intervals.legend' | translate }}
        </legend>
        <mat-select
            class="input"
            panelClass="bar-element-panel"
            [(ngModel)]="intervalOption"
            [hideSingleSelectionIndicator]="true"
            (selectionChange)="handleIntervalChange()"
            (openedChange)="showingIntervals = !showingIntervals">
            <mat-option
                *ngFor="let intervalOption of IntervalsOptions"
                [value]="intervalOption.value"
                class="bar-element-option">
                {{ intervalOption.text | translate }}
            </mat-option>
        </mat-select>
    </fieldset>

    <div class="option">
        <div>
            {{ 'mimic.settings.bar.units.toggle' | translate }}
        </div>
        <div class="option-toggle">
            <div>
                <ng-container *ngIf="!displayUnits">
                    {{ 'dlg.disabled' | translate }}
                </ng-container>
                <ng-container *ngIf="displayUnits">
                    {{ 'dlg.enabled' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle" [checked]="displayUnits" (change)="handleUnitDisplayChange($event)">
            </mat-slide-toggle>
        </div>
    </div>

    <div class="option">
        <div>
            {{ 'mimic.settings.bar.value.toggle' | translate }}
        </div>
        <div class="option-toggle">
            <div>
                <ng-container *ngIf="!displayValue">
                    {{ 'dlg.disabled' | translate }}
                </ng-container>
                <ng-container *ngIf="displayValue">
                    {{ 'dlg.enabled' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle" [checked]="displayValue" (change)="handleValueDisplayChange($event)">
            </mat-slide-toggle>
        </div>
    </div>

    <div class="option">
        <div>
            {{ 'mimic.settings.bar.name.toggle' | translate }}
        </div>
        <div class="option-toggle">
            <div>
                <ng-container *ngIf="!displayName">
                    {{ 'dlg.disabled' | translate }}
                </ng-container>
                <ng-container *ngIf="displayName">
                    {{ 'dlg.enabled' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle" [checked]="displayName" (change)="handleNameDisplayChange($event)">
            </mat-slide-toggle>
        </div>
    </div>
</div>

<ng-container *ngIf="assignedChannel">
    <app-alarm-indicators
        style="width: 100%; padding-top: 12px"
        #elementAlarms
        [assignedChannel]="assignedChannel"
        [activeFlags]="elementSettings?.activeFlags"
        [systemColors]="systemColors">
    </app-alarm-indicators>
</ng-container>
